import React            from 'react'
import { withRouter   } from 'react-router'
import { Link         } from 'react-router-dom'
import { Alert        } from 'react-bootstrap'

import { Registration   } from 'alto-react-base-auth/lib/components'
import { cardNumberForm } from 'alto-react-client-auth/lib/routes'

# used when bill verification is disabled
class LoginCredentialsForm extends Registration.WrappedComponent
  constructor: (props, context) ->
    super(props, context)

    state = props.location.state

    if state and state.card_number
      @cardNumber = state.card_number
    else
      # missing state, redirect back to card number form
      props.history.replace(cardNumberForm)

  register: (credentials) ->
    @context.auth.registerClient(@cardNumber, credentials)

export default withRouter(LoginCredentialsForm)
